import VotesTabContainer from './VotesTabContainer';

export default VotesTabContainer;
